import { SliderScroll } from '../_app/cuchillo/components/SliderScroll';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { gsap } from "gsap";
import Scroll_Item from '../_app/cuchillo/scroll/Scroll_Item';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { GetBy } from '../_app/cuchillo/core/Element';

class ScrollItem__SliderBlueprints extends Scroll_Item {
    _call;
    _slider;

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this._slider = new SliderScroll(__link, {
            interaction: false,
            hasScrollbar: false,
            itemClass: ScrollItem__SliderImages__Item
        });

        this._call = () => this.loop();
        this.onShow = () => {
            gsap.ticker.add(this._call);
        };

        this.onHide = () => {
            gsap.ticker.remove(this._call);
        };
    }

    resize(w, h) {
        super.resize(w, h);
        if (this._slider) this._slider.resize();
    }

    loop() {
        if (this._slider) {
            this._slider.loop();
        }
    }

    dispose() {
        if (this._slider) this._slider.dispose();
        super.dispose();
    }
}

class ScrollItem__SliderImages__Item extends VScroll_Item {
    hasHiddenEnabled = true;
    info;
    infoData;
    fields = {}

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================

    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this.info = GetBy.id(__link.dataset.idInfo);
        const infoEl = GetBy.class("info", __link)[0];

        this.infoData = {
            name: infoEl.querySelector('.name')?.textContent.trim() || '',
            short: infoEl.querySelector('.short')?.textContent.trim() || '',
            description: infoEl.querySelector('.description')?.textContent.trim() || ''
        };
        this.fields = {
            name: GetBy.class("name", this.info)[0],
            short: GetBy.class("short", this.info)[0],
            description: GetBy.class("description", this.info)[0]
        }
    
       

        this.onShow = () => {
           
           this.updateInfo();
        };

        this.onHide = () => {
            
        };
    }

    updateInfo() {
        
        if (this.fields.name) this.fields.name.textContent = this.infoData.name;
        if (this.fields.short) this.fields.short.textContent = this.infoData.short;
        if (this.fields.description) this.fields.description.textContent = this.infoData.description;
    }

    hide () {
        super.hide();
    }
}

Scroll._registerClass('SliderBlueprints', ScrollItem__SliderBlueprints);
